interface Navigator extends globalThis.Navigator {
    deviceMemory?: number
}
type HWindow = { [key: string]: any } & Window & typeof globalThis;
export const win = window as HWindow;
export const doc = document;
export const nav = navigator as Navigator;
export const loc = location;
